export const DEPT_COLORS = {
  District:           { color: '#132c43' },
  NMI:                { color: '#b22222' },
  NYI:                { color: '#000000' },
  NDI:                { color: '#4e504b' },
  'Church Plant':     { color: '#7c5c2a' },
  'Campaign & Rally': { color: '#4a3060' },
};

export const DEPARTMENTS = ['All', 'District', 'NMI', 'NYI', 'NDI', 'Church Plant', 'Campaign & Rally'];

export const EVENTS = [
  

  // District
  { title: 'Ground Dedication', department: 'District', year: 2025, month: 12, day: 14 },
  { title: 'Leadership Workshop', department: 'District', year: 2026, month: 1, day: 31 },
  { title: 'Night of Prayer', department: 'District', year: 2026, month: 2, day: 6 },
  { title: 'Preachers Meeting', department: 'District', year: 2026, month: 3, day: 28 },
  { title: 'Pastors Retreat', department: 'District', year: 2026, month: 5, day: 1 },
  { title: 'Pastors Retreat', department: 'District', year: 2026, month: 5, day: 2 },
  { title: 'Pastors Retreat', department: 'District', year: 2026, month: 5, day: 3 },
  { title: 'Preachers Meeting', department: 'District', year: 2026, month: 7, day: 25 },
  { title: 'Assembly & Rally', department: 'District', year: 2026, month: 10, day: 30 },
  { title: 'Assembly & Rally', department: 'District', year: 2026, month: 10, day: 31 },
  { title: 'Assembly & Rally', department: 'District', year: 2026, month: 11, day: 1 },

  // NMI
  { title: 'Shoe Box', department: 'NMI', year: 2026, month: 1, day: 25 },
  { title: 'Blanket Drive', department: 'NMI', year: 2026, month: 4, day: 25 },
  { title: 'Links Rally', department: 'NMI', year: 2026, month: 6, day: 28 },
  { title: 'Convention', department: 'NMI', year: 2026, month: 10, day: 3 },

  // NYI
  { title: 'Sports Day', department: 'NYI', year: 2026, month: 4, day: 4 },
  { title: 'Youth Week', department: 'NYI', year: 2026, month: 5, day: 27, dayEnd: 29, time: '7:00 PM', location: 'Various Churches'},
  { title: 'Youth Week', department: 'NYI', year: 2026, month: 5, day: 28, time: '7:00 PM', location: 'Sunnyside Church of the Nazarene' },
  { title: 'Youth Week', department: 'NYI', year: 2026, month: 5, day: 29, time: '7:00 PM', location: 'Bonteheuwel Church of the Nazarene' },
  { title: 'Stay Awake', department: 'NYI', year: 2026, month: 6, day: 15 },
  { title: 'Stay Awake', department: 'NYI', year: 2026, month: 6, day: 16 },
  { title: 'Convention', department: 'NYI', year: 2026, month: 10, day: 10 },

  // NDI
  { title: "Men's Camp", department: 'NDI', year: 2025, month: 11, day: 14 },
  { title: "Men's Camp", department: 'NDI', year: 2025, month: 11, day: 15 },
  { title: "Men's Camp", department: 'NDI', year: 2025, month: 11, day: 16 },
  { title: "Children's Camp", department: 'NDI', year: 2026, month: 2, day: 27 },
  { title: "Children's Camp", department: 'NDI', year: 2026, month: 2, day: 28 },
  { title: "Children's Camp", department: 'NDI', year: 2026, month: 3, day: 1 },
  { title: 'Young Adults', department: 'NDI', year: 2026, month: 6, day: 20 },
  { title: "Ladies' Camp", department: 'NDI', year: 2026, month: 8, day: 28 },
  { title: "Ladies' Camp", department: 'NDI', year: 2026, month: 8, day: 29 },
  { title: "Ladies' Camp", department: 'NDI', year: 2026, month: 8, day: 30 },
  { title: 'Special Needs Rally', department: 'NDI', year: 2026, month: 9, day: 20 },
  { title: 'Convention', department: 'NDI', year: 2026, month: 10, day: 17 },

  // Church Plant
  { title: 'Church Plant — Mamre', department: 'Church Plant', year: 2026, month: 3, day: 14 },
  { title: 'Church Plant — Darling', department: 'Church Plant', year: 2026, month: 5, day: 9 },
  { title: 'Church Plant — Langa', department: 'Church Plant', year: 2026, month: 7, day: 5 },

  // Campaign & Rally
  { title: 'Easter Week', department: 'Campaign & Rally', year: 2026, month: 3, day: 30 },
  { title: 'Easter Week', department: 'Campaign & Rally', year: 2026, month: 3, day: 31 },
  { title: 'Easter Week', department: 'Campaign & Rally', year: 2026, month: 4, day: 1 },
  { title: 'Easter Week', department: 'Campaign & Rally', year: 2026, month: 4, day: 2 },
  { title: 'Easter Week', department: 'Campaign & Rally', year: 2026, month: 4, day: 3 },
  { title: 'Easter Week', department: 'Campaign & Rally', year: 2026, month: 4, day: 4 },
  { title: 'Easter Week', department: 'Campaign & Rally', year: 2026, month: 4, day: 5 },
];
